export enum DarkMode {
  LIGHT,
  DARK,
}

export const BG_COLOR: Record<DarkMode, string> = {
  [DarkMode.LIGHT]: '#FFFFFF',
  [DarkMode.DARK]: '#2d363f',
};
